import React, {useEffect, useState} from "react";
import {AddButton} from "../../../helpers/ButtonHelper";
import {dataForSelect, saveData} from "../../../helpers/Api";
import {Alert, Button, Col, Modal, Row} from "react-bootstrap";
import {useMutation, useQuery} from "@apollo/client";
import {getClientMenus, getMenus} from "../menus/MenuQueries";
import Select from "react-select";
import FlashMessage from "../../shared/FlashMessage";
import {AddClientMenu, getClientById} from "./ClientQueries";

const AssignMenuToClientModal = ({
                                   client,
                                   clientMenus,
                                   onClose,
                                   shouldOpen,
                                   showButton = true
                                 }) => {
  const [show, setShow] = useState(false);
  const [flash, setFlash] = useState({});
  const { data, loading } = useQuery(getMenus, { fetchPolicy: 'network-only' })
  const [gqlCall] = useMutation(AddClientMenu, { refetchQueries: [getClientMenus, getClientById] })

  const menuIds = clientMenus.map(a => parseInt(a.parentMenuId))
  let menusList = data && data.menus.filter(menu =>
    !menuIds.includes(parseInt(menu.id))
  )

  const closeModal = () => {
    setFlash({})
    setShow(false);
    if (onClose) onClose();
  }

  const showModal = (e) => {
    e.preventDefault()
    setShow(true);
  }

  useEffect(() => {
    if (shouldOpen) {
      showModal(true)
    }
  }, [shouldOpen])

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: gqlCall,
      query_key: 'addClientMenu',
      success: (res) => {
        closeModal()
      },
      flash_callback: setFlash
    })
  }

  return (
    <>
      {showButton && <AddButton to='#' onClick={showModal} size='sm' />}

      <Modal show={show} onHide={closeModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Adauga un meniu pentru {client.fullName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!loading &&
            <div className="container">
              <div className="row justify-content-md-center">

                <form onSubmit={onSubmit}>
                  <input type='hidden' name='clientId' id="clientId" defaultValue={client.id} />
                  <Row>
                    <Col>
                      {menusList.length === 0 &&
                        <Alert variant='warning'>Acest client are acces la toate meniurile</Alert>
                      }
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                    <Col>
                      <label htmlFor='menu'>Meniu</label>
                      <Select name='menuId' id='menu' className="basic-single"
                              options={data && dataForSelect(menusList)}
                      />
                    </Col>
                    <Col>
                      <label htmlFor='menu'>Status</label>
                      <Select name='status' id='status' className="basic-single"
                              options={data && dataForSelect([{ name: 'Activ', id: 'active' }, {
                                name: 'Inactiv',
                                id: 'inactive'
                              }])}
                      />
                    </Col>
                  </Row>
                  <hr />
                  <Row className='mb-3'>
                    <FlashMessage flash={flash} buttons={
                      <>
                        {/*<BackButton className='float-end' showText={true} size='md' text='Inchide'*/}
                        {/*            onClick={closeModal}/>*/}
                        <Button type='submit' className='float-end'>Salveaza</Button>
                      </>
                    } />
                  </Row>
                </form>
              </div>
            </div>
          }
        </Modal.Body>
      </Modal>
    </>
  )
};

export default AssignMenuToClientModal;
